import { render, staticRenderFns } from "./apply_detail.vue?vue&type=template&id=15a4e6ff&scoped=true"
import script from "./apply_detail.vue?vue&type=script&lang=js"
export * from "./apply_detail.vue?vue&type=script&lang=js"
import style0 from "./apply_detail.vue?vue&type=style&index=0&id=15a4e6ff&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4e6ff",
  null
  
)

export default component.exports